module.exports = __webpack_public_path__ + "static/media/competitiveinfluencerreports.9b54d01b.png";